module.exports = __webpack_public_path__ + "f0eae720f2fb571d3749ffb14d9b58eb.svg";